<template>
  <!-- -->
  <div class="defaultViewStyle">

    <div class="login-panel">
      正在加载。。。
      <div id="qywxLogin"></div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
// import qywxUtil from "@/util/qywxUtil";
// import * as ww from "@wecom/jssdk";
import baseApi from "@/api/baseApi";
import util from "@/util/util";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "QL",
  components: {
  },
  data() {
    return {
      backgroundImage: "",
      userInfo: {}
    };
  },
  created() {
    console.log(this.route.query)
    //
    let code = this.route.query.code;
    if (code) {
      const clientType = util.getContextPath() === 3 ? "QYWX_MOBILE" : "QYWX_PC";
      baseApi.loginEmployeeByQywxCode(code, clientType).then(user => {
        this.userInfo = user;
        console.log("登录成功", user);
        util.clearCacheData();// 清空缓存,
        util.setUserInfo(user); // 设置登录信息
        this.$nextTick().then(() => {
          // 获取当前登录的环境
          this.toMainPage();
        })
      });
    }
  },
  mounted() {
    this.$nextTick().then(() => {
      this.init();
    });
  },
  methods: {
    // 跳转到主页
    toMainPage() {
      console.log("登录成功,跳转页面")
      // 当前登录页面是电脑还是手机
      // 检查运行环境
      let context = util.getContextPath();
      // 如果是从正式页面打开的
      let state = this.route.query.state;
      // ★ 必须用 replace：企业微信回调的 code 是一次性的，登录页不能留在历史记录里，
      //   否则浏览器回退会回到带 code 的登录页，二次触发直接报 code 已使用。
      if (state && state.startsWith("/")) {
        console.log("跳转页面", state)
        this.router.replace(state);
      } else if (context === 2) { // 企业微信PC端
        this.router.replace(`/welcome`)
      } else if (context === 3) { // 企业微信移动端
        this.router.replace(`/qywx/home`)
      }
    },
    init() {
      this.backgroundImage = process.env.VUE_APP_SYSTEM_BACKGROUND;
      // 使用企业微信扫码登录
      // ww.createWWLoginPanel({
      //   el: '#qywxLogin',
      //   params: {
      //     login_type: 'ServiceApp',
      //     appid: 'wwa32edfbc623c7e4a', // 这个是在服务商后台-通用管理配置的登录功能
      //     redirect_uri: 'https://portal.xyyqgj.top/qywx/loginUser',
      //     state: 'fenghuolun',
      //     redirect_type: 'callback',
      //   },
      //   onCheckWeComLogin({ isWeComLogin }) {
      //     console.log(isWeComLogin)
      //   },
      //   onLoginSuccess({ code }) {
      //     // 这里会直接获得code，使用code进行登录
      //     console.log({ code })
      //   },
      //   onLoginFail(err) {
      //     console.log(err)
      //   },
      // })
    }
  }
};
</script>

<style lang="scss" scoped>
.defaultViewStyle{
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  .login-panel{
    width: 100%;
    text-align: center;
    #qywxLogin{
      display: inline-block;
      border-radius: 10px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
      overflow: hidden;
    }
  }
}
</style>